import l10n from "flatpickr/dist/l10n/index.js";
// NEXT-327: This is a workaround to extend the l10n type from flatpickr library to add the 'mx' locale key to it (as a 'es' alias).
export const l10nExtended = {
    ...l10n,
    mx: l10n.es
};

//# sourceMappingURL=types.js.map